import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from '../../../ok-alone.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Contract } from '../../../interfaces/contract';
import { translate, TranslocoService } from '@ngneat/transloco';
import { TERMS_AND_CONDITIONS } from '../../../constants/terms-and-conditions';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AngularSignaturePadModule, NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { Plan2024Component } from '../plan2024/plan2024.component';
import { PlanComponent } from '../plan/plan.component';
import {
  confirmPlanAcceptance as showPlanAcceptanceConfirm,
  getPlanDisplayName,
  planTypeFromContract,
} from '../../../plan-acceptance';

@Component({
  selector: 'app-account-signup',
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss'
})
export class SignupComponent implements OnInit, AfterViewInit {
  
  @ViewChild('termsScroll') termsScroll!: ElementRef<HTMLDivElement>;
  @ViewChild('signature') signature!: SignaturePadComponent;
  @ViewChild(Plan2024Component) plan2024?: Plan2024Component;
  @ViewChild(PlanComponent) accountPlan?: PlanComponent;

  // Terms and conditions
  hasScrolledToBottom = false;
  currentDate = new Date();
  termsAndConditions: SafeHtml;

  // Signature pad
  signature_name: string = '';
  submitted = false;
  signaturePadOptions: NgSignaturePadOptions = {
    minWidth: 1,
    backgroundColor: 'rgb(255, 255, 255)',
    penColor: 'rgb(68, 68, 68)',
    dotSize: 1,
    canvasContextOptions: {
      willReadFrequently: true
    }
  };

  contract:any;

  step = 1;

  hide_contract_form:any = null;
  is_live:any = null;
  max_workers:any = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute, 
    public okService: OkAloneService,
    private transloco: TranslocoService,
    private sanitizer: DomSanitizer
  ) {
    this.termsAndConditions = this.sanitizer.bypassSecurityTrustHtml(TERMS_AND_CONDITIONS);
  }

  ngOnInit(): void {
    this.getBilling();
    this.getContract();
  }

  
  getContract(){
    this.okService.get('billing/contract',{})
    .subscribe((response:any) => {

      let data = response.body;
      console.log(data);

      if(data['contract']){

        let contract = data['contract'];
        this.hide_contract_form = contract.hide_contract_form;
        this.is_live = contract.is_live;
        this.max_workers = contract.max_workers;

      }


    });

    
  }


  ngAfterViewInit(): void {
    // Initialize signature pad
  }

  drawComplete(event: MouseEvent | Touch) {
    //console.log('Completed drawing', event);
  }

  drawStart(event: MouseEvent | Touch) {
    //console.log('Start drawing', event);
  }

  submitSignature() {
    this.submitted = true;
    
    if (!this.signature || this.signature.isEmpty() || !this.signature_name) {
      return;
    }

    // Get the signature as a base64 PNG
    const signatureData = this.signature.toDataURL('image/png');

    
    
    // Update the contract object
    this.contract.signatureImage = signatureData;
    this.contract.signedBy = this.signature_name;
    this.contract.signedDate = new Date().toISOString();

    let data = {
      step: 4,
      information: "Signature Submitted",
      signed_date: new Date().toISOString(),
      signed_by: this.signature_name,
      signature_image: signatureData,
      completed: !this.contract.show_cc
    };

    this.okService.put("contract/update",data)
    .subscribe((data:any) => {
      //console.log(data.body);

      this.getBilling();
    })

  }

  getBilling(){
    this.okService.get("contract",{})
    .subscribe((data:any) => {

      this.contract = data.body;

      //console.log(this.contract);

      this.step = this.contract.step;


    })
  }

  submitPlanConfirmed(){
    if (!this.confirmPlanAcceptance()) {
      return;
    }

    let data = {
      step: 2,
      information: "Plan Confirmed"
    };

    this.okService.put("contract/update",data)
    .subscribe((data:any) => {
      //console.log(data.body);

      this.getBilling();
    })
  }

  submitTandCsConfirmed(){

    let data = {
      step: 3,
      read: true,
      information: "Terms and Conditions Accepted"
    };

    this.okService.put("contract/update",data)
    .subscribe((data:any) => {
      //console.log(data.body);

      this.getBilling();
    })

  }


  nextStep(){
    if(this.step == 1){
      this.step = 2;  
    }else if(this.step == 2){
      this.step = 3;
    }else if(this.step == 3){
      this.step = 4;
    }
  }
  previousStep(){
    if(this.step == 2){
      this.step = 1;  
    }else if(this.step == 3){
      this.step = 2;
    }else if(this.step == 4){
      this.step = 3;
    }
  }

  onTermsScroll(event: any): void {
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;
    this.hasScrolledToBottom = atBottom;
  }

  getStep(){
    if(!this.contract.show_plan){
      return this.step-1;
    }
    return this.step;
  }

  private confirmPlanAcceptance(): boolean {
    const planName = this.getConfirmPlanName();
    const workers = this.getConfirmWorkerCount();
    return showPlanAcceptanceConfirm(planName, workers);
  }

  private getConfirmPlanName(): string {
    if (this.plan2024?.plan?.type) {
      return getPlanDisplayName(this.plan2024.plan.type);
    }

    if (this.accountPlan?.plan) {
      const plan = this.accountPlan.plan;
      if (plan.live_monitoring) {
        return getPlanDisplayName('monitoring');
      }
      if (plan.call_plan) {
        return getPlanDisplayName('automated');
      }
      return getPlanDisplayName('essentials');
    }

    return getPlanDisplayName(planTypeFromContract(this.contract));
  }

  private getConfirmWorkerCount(): number {
    if (this.plan2024?.plan?.workers != null) {
      return +this.plan2024.plan.workers;
    }

    if (this.accountPlan?.plan?.workers != null) {
      return +this.accountPlan.plan.workers;
    }

    return +(this.contract?.max_workers ?? 0);
  }
}

